import React, { useContext, useEffect, useState } from 'react'
import { DrapingRecharge } from './DrapingRecharge'
import { GetRechargePlanInfo } from '../../../../configurations/crud/rechargeHistoryCrud'
import { GetRechargePlanInfoSms } from '../../../../configurations/crud/rechargeHistoryCrud'
import { DrapingRechargeSms } from '../rechargeSmsPlans/DrapingRechargeSms'
import ContainerTwo from '../../../base/ContainerTwo'
import { MdErrorOutline } from 'react-icons/md'
import { useToast } from '../../../controls/Toast/ToastService'
import Getbalance from '../../rechargeHistory/Getbalance'
import useGlobalLoader from '../../../../configurations/useGlobalLoader'


export function RechargePlansDashboard() {
    const {start,end} = useGlobalLoader()
    const [isLoadingMini, setIsLoadingMini] = useState(false)
    const [rechargeDraping, setRechargeDraping] = useState()
    const [rechargeSms, setRechargeSms] = useState()
    const [selectedDrapingCount, setSelectedDrapingCount] = useState(100)
    const [selectedSmsCount, setSelectedSmsCount] = useState(100)
    const [rechargePlan, setRechargePlan] = useState(0)
    const toast = useToast()

    useEffect(() => {
        getRechargeDraping()
    }, [selectedDrapingCount])

    useEffect(() => {
        getRechargeSms()
    }, [selectedSmsCount])

    function getRechargeDraping() {
        setIsLoadingMini(true);
        start()
        GetRechargePlanInfo(selectedDrapingCount)
            .then(res => {
                if (res.data) {
                    if (res.data.result.succeeded) {
                        let hdata = res.data
                        setRechargeDraping(hdata);
                        setIsLoadingMini(false)
                        end()
                    }
                    else {
                        setIsLoadingMini(false)
                        end()
                        setRechargeDraping();
                    }
                }
                else {
                    setIsLoadingMini(false)
                    end()
                    setRechargeDraping();
                    toast.open("Server Error /Invalid Try.", <MdErrorOutline />, 'error')

                }
            })
            .catch(error => {
                setIsLoadingMini(false);
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            })
    }

    function getRechargeSms() {
        setIsLoadingMini(true);
        start()
        GetRechargePlanInfoSms(selectedSmsCount)
            .then(res => {
                if (res.data) {
                    if (res.data.result.succeeded) {
                        let hdata = res.data
                        setRechargeSms(hdata);
                        setIsLoadingMini(false)
                        end()
                    }
                    else {
                        setIsLoadingMini(false)
                        end()
                        setRechargeSms();
                    }
                }
                else {
                    setIsLoadingMini(false)
                    end()
                    setRechargeSms();
                    toast.open("Server Error /Invalid Try.", <MdErrorOutline />, 'error')
                }
            })
            .catch(error => {
                setIsLoadingMini(false);
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            })
    }

    const ProceedToPlan = () => {
        if (rechargeDraping.totalAmount > 0)
            setRechargePlan(4)
        else {
            toast.open("Invalid recharge amount.", <MdErrorOutline />, 'warning')
        }
    }
    const ProceedToSmsPlan = () => {
        if (rechargeSms.totalAmount > 0)
            setRechargePlan(3)
        else {
            toast.open("Invalid recharge amount.", <MdErrorOutline />, 'warning')
        }
    }
    return (
        <ContainerTwo title='RechargePlans'>
            <div className="md:px-8"><Getbalance />
            </div>
            {rechargePlan == 0 && (
                <div className="p-4 sm:p-8 -mt-4">
                    <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-8">
                        {/* OPD Plan - now part of grid */}
                        <div className="bg-white rounded-xl shadow-md overflow-hidden">
                            <div className="md:hidden bg-brand-500 text-white p-4">
                                <h3 className="font-semibold text-lg">Recharge OPD Plan</h3>
                            </div>
                            <table className="w-full">
                                <thead className="hidden md:table-header-group bg-brand-500 text-white">
                                    <tr>
                                        <th className="w-2/3 px-4 sm:px-6 py-4 text-left font-semibold text-sm uppercase tracking-wider">Plan Details</th>
                                        <th className="w-1/3 px-4 sm:px-6 py-4 text-center font-semibold text-sm uppercase tracking-wider">Recharge OPD</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                    <tr className="hover:bg-gray-50 transition-colors">
                                        <td className="px-4 sm:px-6 py-4">
                                            <div className="text-sm font-medium text-gray-900">Select Your Plan</div>
                                            <div className="text-sm text-gray-500">Choose the number of OPDs you need</div>
                                        </td>
                                        <td className="px-4 sm:px-6 py-4">
                                            <select
                                                className="block w-full py-2 text-base border border-gray-300 focus:outline-none focus:ring-brand-500 focus:border-brand-500 sm:text-sm rounded-md bg-gray-50"
                                                value={selectedDrapingCount}
                                                onChange={(e) => setSelectedDrapingCount(e.target.value)}
                                            >
                                                <option value="100">100 OPD</option>
                                                <option value="200">200 OPD</option>
                                                <option value="300">300 OPD</option>
                                                <option value="400">400 OPD</option>
                                                <option value="500">500 OPD</option>
                                                <option value="600">600 OPD</option>
                                                <option value="700">700 OPD</option>
                                                <option value="800">800 OPD</option>
                                                <option value="900">900 OPD</option>
                                                <option value="1000">1000 OPD</option>
                                                <option value="2000">2000 OPD</option>
                                                <option value="5000">5000 OPD</option>
                                                <option value="10000">10000 OPD</option>
                                            </select>
                                        </td>
                                    </tr>

                                    {rechargeDraping && (
                                        <>
                                            <tr className="hover:bg-gray-50 transition-colors">
                                                <td className="px-4 sm:px-6 py-4 text-sm font-medium text-gray-700">Per OPD Rate</td>
                                                <td className="px-4 sm:px-6 py-4 text-sm text-gray-900 text-center md:text-left">
                                                    ₹{Number(rechargeDraping.perOPDRate).toFixed(2)}
                                                </td>
                                            </tr>
                                            <tr className="hover:bg-gray-50 transition-colors">
                                                <td className="px-4 sm:px-6 py-4 text-sm font-medium text-gray-700">Net Amount</td>
                                                <td className="px-4 sm:px-6 py-4 text-sm font-semibold text-gray-900 text-center md:text-left">
                                                    ₹{Number(rechargeDraping.netAmount).toFixed(2)}
                                                </td>
                                            </tr>
                                            <tr className="hover:bg-gray-50 transition-colors">
                                                <td className="px-4 sm:px-6 py-4 text-sm font-medium text-gray-700">GST ({rechargeDraping.gstSlab}%)</td>
                                                <td className="px-4 sm:px-6 py-4 text-sm text-gray-900 text-center md:text-left">
                                                    ₹{Number(rechargeDraping.gstAmount).toFixed(2)}
                                                </td>
                                            </tr>
                                            <tr className="bg-brand-50 hover:bg-brand-100 transition-colors">
                                                <td className="px-4 sm:px-6 py-4 text-lg font-bold text-brand-700">Total Amount</td>
                                                <td className="px-4 sm:px-6 py-4 text-lg font-bold text-brand-700 text-center md:text-left">
                                                    ₹{Number(rechargeDraping.totalAmount).toFixed(2)}
                                                </td>
                                            </tr>
                                        </>
                                    )}

                                    {rechargeDraping?.totalAmount > 0 && (
                                        <tr>
                                            <td colSpan="2" className="px-4 sm:px-6 py-4">
                                                <button
                                                    onClick={() => ProceedToPlan()}
                                                    className="w-full bg-brand-500 hover:bg-brand-700 text-white font-semibold py-3 px-4 rounded-lg shadow-md transition-colors duration-200 transform hover:scale-[1.01] focus:outline-none focus:ring-2 focus:ring-brand-500 focus:green-offset-2"
                                                >
                                                    Pay ₹{Number(rechargeDraping.totalAmount).toFixed(2)}
                                                </button>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        
                        
                    </div>
                </div>
            )}
            {rechargePlan == 4 &&
                <DrapingRecharge setRechargePlan={setRechargePlan} data={rechargeDraping} />
            }
            {rechargePlan == 3 &&
                <DrapingRechargeSms setRechargePlan={setRechargePlan} data={rechargeSms} />
            }

        </ContainerTwo>
    )
}
